import { render, staticRenderFns } from "./FormExpired.vue?vue&type=template&id=33e81dd8"
import script from "./FormExpired.vue?vue&type=script&lang=ts"
export * from "./FormExpired.vue?vue&type=script&lang=ts"
import style0 from "./FormExpired.vue?vue&type=style&index=0&id=33e81dd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports